import React, { useEffect, useState } from 'react';
import { StyleSheet, TouchableOpacity, Image } from 'react-native';
import { FontAwesome5 } from '@expo/vector-icons';

import {
  getProductCategoriesData,
  deleteProductCategory,
  getQuantitiesByCategory,
} from '../../../../api/Product';
import { msgStr } from '../../../../common/constants/Message';
import { API_URL } from '../../../../common/constants/AppConstants';
import { TextMediumSize } from '../../../../common/constants/Fonts';
import { useAlertModal, useConfirmModal } from '../../../../common/hooks';
import { BasicLayout, CommonContainer } from '../../../../common/components/CustomLayout';
import { BOHButton, BOHToolbar } from '../../../../common/components/bohtoolbar';
import { BOHTBody, BOHTD, BOHTDIconBox, BOHTDImageBox, BOHTH, BOHTHead, BOHTR, BOHTable } from '../../../../common/components/bohtable';

import AddProductCategoryModal from './AddProductCategoryModal';
import UpdateProductCategoryModal from './UpdateProductCategoryModal';
import { useSorting } from '../../../../common/hooks/useSorting';

const ProductCategories = ({ navigation, openInventory }) => {

  const { showAlert } = useAlertModal();
  const { showConfirm } = useConfirmModal();

  const [tableData, setTableData] = useState([]);
  const [updateProductCategoryTrigger, setUpdateProductCategoryTrigger] = useState(true);

  const [isAddModalVisible, setAddModalVisible] = useState(false);
  const [isUpdateModalVisible, setUpdateModalVisible] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);

  const InitialWidths = [220, 90, 90, 50, 50];

  const openAddProductCategoryModal = () => {
    setAddModalVisible(true);
  };
  const closeAddProductCategoryModal = () => {
    setAddModalVisible(false);
  };

  const editProductCategory = (item) => {
    setSelectedCategory(item);
    setUpdateModalVisible(true);
  };
  const closeUpdateProductCategoryModal = () => {
    setUpdateModalVisible(false);
  };
  
  useEffect(() => {
    if (updateProductCategoryTrigger == true) getTable();
  }, [updateProductCategoryTrigger]);

  const removeProductCategory = (id) => {
    showConfirm(msgStr('deleteConfirmStr'), () => {
      deleteProductCategory(id, (jsonRes, status, error) => {
        switch (status) {
          case 200:
            setUpdateProductCategoryTrigger(true);
            showAlert('success', jsonRes.message);
            break;
          default:
            if (jsonRes && jsonRes.error) showAlert('error', jsonRes.error);
            else showAlert('error', msgStr('unknownError'));
            break;
        }
      });
    });
  };

  const getTable = () => {
    getProductCategoriesData((jsonRes, status, error) => {
      switch (status) {
        case 200:
          setUpdateProductCategoryTrigger(false);
          setQuantities(jsonRes);
          break;
        case 500:
          showAlert('error', msgStr('serverError'));
          break;
        default:
          if (jsonRes && jsonRes.error) showAlert('error', jsonRes.error);
          else showAlert('error', msgStr('unknownError'));
          break;
      }
    });
  };

  const setQuantities = (tableData) => {
    getQuantitiesByCategory((jsonRes, status, error) => {
      switch (status) {
        case 200:
          if (jsonRes) {
            for (let i = 0; i < tableData.length; i++) {
              let id = tableData[i].id;
              if (jsonRes[id] !== undefined) {
                tableData[i].quantity = jsonRes[id];
              }
            }
          }
          setTableData(tableData);
          break;
        case 500:
          showAlert('error', msgStr('serverError'));
          break;
        default:
          if (jsonRes && jsonRes.error) showAlert('error', jsonRes.error);
          else showAlert('error', msgStr('unknownError'));
          break;
      }
    });
  };
  const { sortedData, handleSort, sorting } = useSorting('product_categories', tableData, { key: 'category', direction: 'ascending' });

  const renderTableData = () => {
    const rows = [];
    if (sortedData.length > 0) {
      sortedData.map((item, index) => {
        rows.push(
          <BOHTR key={index}>
            <BOHTD width={InitialWidths[0]}>{item.category}</BOHTD>
            <BOHTD width={InitialWidths[1]} textAlign={'right'}>{item.quantity ? item.quantity : '0'}</BOHTD>
            <BOHTDImageBox width={InitialWidths[2]} imgURL={ API_URL + item.img_url }/>
            <BOHTDIconBox width={InitialWidths[3]}>
              <TouchableOpacity
                onPress={() => {
                  editProductCategory(item);
                }}
              >
                <FontAwesome5 size={TextMediumSize} name="edit" color="black" />
              </TouchableOpacity>
            </BOHTDIconBox>
            <BOHTDIconBox width={InitialWidths[4]}>
              <TouchableOpacity
                onPress={() => {
                  removeProductCategory(item.id);
                }}
              >
                <FontAwesome5 size={TextMediumSize} name="times" color="black" />
              </TouchableOpacity>
            </BOHTDIconBox>
          </BOHTR>
        );
      });
    } else {
      <></>;
    }
    return <>{rows}</>;
  };
  const headers = [
    { key: 'category', label: 'Category' },
    { key: 'quantity', label: 'Quantity' }
  ];
  return (
    <BasicLayout
      navigation={navigation}
      goBack={() => {
        openInventory(null);
      }}
      screenName={'Product Categories'}
    >
      <CommonContainer>
        <BOHToolbar>
          <BOHButton
            label='Add'
            onPress={openAddProductCategoryModal}/>
        </BOHToolbar>
        <BOHTable>
          <BOHTHead>
            <BOHTR>
              {headers.map(({ key, label }, wIndex) => (
                <BOHTH
                  key={key}
                  width={InitialWidths[wIndex++]}
                  isSorted={sorting.key === key}
                  direction={sorting.key === key ? sorting.direction : null}
                  onClick={() => handleSort(key)}
                >
                  {label}
                </BOHTH>
              ))}
              <BOHTH width={InitialWidths[2]}>{'Image'}</BOHTH>
              <BOHTH width={InitialWidths[3]}>{'Edit'}</BOHTH>
              <BOHTH width={InitialWidths[4]}>{'DEL'}</BOHTH>
            </BOHTR>
          </BOHTHead>
          <BOHTBody>
            {renderTableData()}
          </BOHTBody>
        </BOHTable>

        <AddProductCategoryModal
          isModalVisible={isAddModalVisible}
          setUpdateProductCategoryTrigger={setUpdateProductCategoryTrigger}
          closeModal={closeAddProductCategoryModal}
        />

        {selectedCategory && (
          <UpdateProductCategoryModal
            isModalVisible={isUpdateModalVisible}
            item={selectedCategory}
            setUpdateProductCategoryTrigger={setUpdateProductCategoryTrigger}
            closeModal={closeUpdateProductCategoryModal}
          />
        )}
      </CommonContainer>
    </BasicLayout>
  );
};

export default ProductCategories;
